import { Progress } from '@/components/atoms/progress';

interface FormProgressIndicatorProps {
  completed: number;
  total: number;
  label?: string;
  additionalInfo?: string;
}

export function FormProgressIndicator({
  completed,
  total,
  label = 'fields completed',
  additionalInfo,
}: FormProgressIndicatorProps) {
  const progress = total > 0 ? (completed / total) * 100 : 0;

  return (
    <div className="mb-6 p-4 bg-muted/50 rounded-lg">
      <div className="flex justify-between text-sm mb-2">
        <span>
          {completed}/{total} {label}
        </span>
        <span>{Math.round(progress)}%</span>
      </div>
      <Progress value={progress} className="h-2" />
      {additionalInfo && (
        <p className="text-xs text-muted-foreground mt-2">{additionalInfo}</p>
      )}
    </div>
  );
}
